// removed by extract-text-webpack-plugin
module.exports = {"termsOfUse":"TermsOfUse__termsOfUse___2oVkW","pageTitle":"TermsOfUse__pageTitle___2lPMM","subTitle":"TermsOfUse__subTitle___l8DB9"};